import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-NewConstruction',
    templateUrl: './NewConstruction.component.html',
    styleUrls: ['./NewConstruction.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewConstructionComponent implements OnInit, AfterViewInit {


  id: number;

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }
  ngAfterViewInit() {

  }

  ngOnInit() {
  }

}
